import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'onelog-page-header',
  templateUrl: './onelog-page-header.component.html',
  styleUrls: ['./onelog-page-header.component.scss']
})
export class OnelogPageHeaderComponent {

  @Input() title = '';
  @Input() backToUrl: string | undefined = undefined;

  constructor(
    private router: Router,
  ) { }

  navigateBack(): void {
    if (this.backToUrl) {
      void this.router.navigateByUrl(this.backToUrl);
    }
  }

}
